import { useCallback, useState } from 'react';

export default function useRerender() {
  const [, rerender] = useState({});
  return useCallback(() => rerender({}), []);
}
